import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../Theme/Theme";
import AccountInfo from "./AccountInfo";
import EditName from "./Settings/EditName";
import EditEmail from "./Settings/EditEmail";
import EditPassword from "./Settings/EditPassword";
import EditPlan from "./Settings/EditPlan";
import EditPaymentMethod from "./Settings/EditPaymentMethod";
import Unsubscribe from "./Unsubscribe";
import Coupon from "./Settings/Coupon";
import Home from "./Home";
import HomeFooter from "./HomeFooter";
import HomeHeader from "./HomeHeader";
import Show from "./Shows/Show";
import Mobile from "./Mobile.jsx";
import Playlists from "./Playlists/Playlists";
import PlayList from './Playlists/PlayList'
import SideNav from "./SideNavigation.jsx";
import * as Actions from "../../Actions/Actions.js";

class HomeRouter extends Component {
  render() {
    const { classes } = this.props;
    const { Image, Container } = classes;
    return (
      <div>
        <img
          src="../../../Assets/flat_grid_bright.png"
          alt=""
          className={Image}
        />
        <div className={Container}>
          <div style={{ position: "sticky", top: "0", zIndex: "2" }}>
            {this.props.history.location.pathname.includes('/Home/Show') ? null : (
              <HomeHeader />
            )}
          </div>
          {this.props.history.location.pathname === "/Home" &&
          this.props.library != undefined ? (
            <SideNav />
          ) : null}
          <Switch>
            <Route exact path="/Home" component={Home} />
            <Route path="/Home/AccountInfo" component={AccountInfo} />
            <Route path="/Home/EditName" component={EditName} />
            <Route path="/Home/EditEmail" component={EditEmail} />
            <Route path="/Home/EditPassword" component={EditPassword} />
            <Route path="/Home/EditPlan" component={EditPlan} />
            <Route
              path="/Home/EditPaymentMethod"
              component={EditPaymentMethod}
            />
            <Route path="/Home/Unsubscribe" component={Unsubscribe} />
            <Route path="/Home/Coupon" component={Coupon} />
            <Route path="/Home/Show/:playCount" component={Show} />
            <Route path="/Home/Mobile" component={Mobile} />
            <Route exact path="/Home/playlists/:title" component={PlayList} />
            <Route exact path="/Home/playlists" component={Playlists} />
            <Redirect to="/Home"/>
          </Switch>
          {/* {this.returnCastButton()} */}
          {this.props.history.location.pathname.includes('/Home/Show') || this.props.history.location.pathname.includes('Home/playlists/') || this.props.history.location.pathname.includes('Home/accountInfo') || this.props.history.location.pathname.includes('Home/AccountInfo') ? null : (
              <HomeFooter />
          )}
        </div>
      </div>
    );
  }

  componentDidMount() {
    // this.props.dispatch(Actions.getSettings(this.propsauto))
  }
}

const styles = {
  ...flexUtils,
  Image: {
    position: "fixed",
    width: "100vw",
    height: "100vh",
    top: "0",
    left: "0",
    filter: "blur(20px)",
    zIndex: "-2"
  },
  Container: {
    composes: ["$FlexColumn", "$FlexCenter"],
    justifyContent: "flex-start",
    height: "100%",
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: "rgb(0,0,0)",
    overflowY: "scroll",
    overflowX: "hidden"
    // background: `linear-gradient(45deg, ${Color(palette.pink).darken(0.6).alpha(0.9)}, ${Color(palette.purple).darken(0.6).alpha(0.9)}, ${Color(palette.blue).darken(0.6).alpha(0.9)}, ${Color(palette.teal).darken(0.6).alpha(0.9)})`
  },
  Section: {
    composes: ["$FlexColumn", "$FlexCenter"],
    width: "100%",
    textAlign: "center",
    color: "rgb(80, 80, 80)"
  },
  Header: {
    composes: "$Section",
    padding: "1rem",
    minHeight: "8rem",
    width: "100%",
    "& img": {
      width: "70%",
      maxWidth: "20rem"
    }
  }
};

const mapStateToProps = state => {
  return { user: state.mainState.user, library: state.mainState.library };
};

export default withRouter(
  connect(mapStateToProps)(injectSheet(styles)(HomeRouter))
);



// WEBPACK FOOTER //
// ./src/js/Components/Home/HomeRouter.jsx